const opiniones = [
  {
    nombre: "Patricia Rodríguez",
    mensaje:
      "Ricardo le dio clases a mis hijos cuando tenian 9 y 10 años y les enganchó tanto que casi 3 años despues se buscan la cancion que sea en internet y son capaces de tocarla perfectamente. Mi hija esta enganchadisima!! muchas gracias por todo!"
  },
  {
    nombre: "Dr. Javier Prieto (Prieto&Serrano)",
    mensaje:
      "Inmejorable profesional y persona, con una increíble capacidad para transmitir a los niños la pasión por la música y su aprendizaje que hace ameno, cercano y adaptado a cada alumno. No podría recomendarlo más y espero de corazón que tenga fortuna en su nueva aventura."
  },
  {
    nombre: "Vanessa Medici",
    mensaje:
      "Confirmo. Profesional muy recomendable. Trabaja con sus alumnos de manera individualizada y paciente, logrando resultados súper. Trasmite su entusiasmo y su clase nunca es aburrida. Consiguió, en pocas clases, que mi hijo disléxico y falta de atención, aprendiera los acordes rápidamente."
  },
  {
    nombre: "Lucía Álvarez",
    mensaje: 
      "Empecé las clases de guitarra sin mucha experiencia, pero desde la primera clase me sentí super cómoda. En pocas semanas ya pude tocar mis primeras canciones completas, algo que no pensé que lograría tan rápido. Además, siempre salgo de clase motivada y con ganas de seguir practicando. Estoy encantadísima con las clases y las recomiendo al 100%."
  },
  {
    nombre: "Yeray Molina",
    mensaje:
      "Llegué con muchas ganas de tocar y me fui con ganas de seguir aprendiendo todos los días. Rick explica claro, sin rodeos, y hace que la guitarra deje de ser un misterio imposible para mí."
  }
];

export function Testimonios() {
  return (
    <section className="py-10 sm:py-12 bg-gray-200">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-3xl sm:text-5xl md:text-7xl font-bold text-blue-900/70 mb-8 md:mb-12 tracking-wider">
          COMENTARIOS
        </h2>
        <ul className="grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8 md:[&>li]:col-span-2 md:[&>li:nth-last-child(2)]:col-start-2">
          {opiniones.map((op, i) => (
            <li key={i} className="bg-white shadow-xl rounded-xl px-4 py-6 sm:p-6 flex flex-col justify-center min-h-[220px]">
              <span className="block text-center text-blue-900 font-bold mb-2 text-base sm:text-lg">{op.nombre}</span>
              <p className="text-center text-sm sm:text-lg font-medium text-gray-700 mb-4 italic font-normal">&quot;{op.mensaje}&quot;</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
